import {useController, useFormContext} from "react-hook-form";
import {FormField, FormFieldError} from "../../../../../../design-system/form-field";
import {Input, Space} from "antd";
import {LiveEventSubGenInfoNameFormFieldProps} from "./types";
import {useEffect, useState} from "react";
import type {FocusEvent} from "react";
import {LiveEventGenInfoFormFields} from "../../types";

export function LiveEventSubGenInfoNameFormField({
  id,
  label,
  placeholder,
}: LiveEventSubGenInfoNameFormFieldProps) {
  const {control} = useFormContext<LiveEventGenInfoFormFields>();

  const {field, fieldState} = useController({
    name: "name",
    control,
  });
  const fieldValue = field.value as string | undefined;

  const [nameValue, setNameValue] = useState<string | undefined>(fieldValue);

  useEffect(() => {
    setNameValue(fieldValue);
  }, [fieldValue]);

  function handleBlur(e: FocusEvent<HTMLInputElement, Element>) {
    field.onChange(e);
    field.onBlur();
  }

  function handleChange(e: FocusEvent<HTMLInputElement, Element>) {
    setNameValue(e.target.value);
  }

  return (
    <div>
      <FormField
        id={id}
        label={label}
        renderInput={(id) => (
          <Space direction="vertical" size={16} style={{display: "flex"}}>
            <Input
              id={id}
              status={fieldState.error?.message ? "error" : ""}
              value={nameValue}
              onChange={handleChange}
              onBlur={handleBlur}
              size="large"
              placeholder={placeholder}
              ref={field.ref}
            />
            <FormFieldError errorMessage={fieldState.error?.message} />
          </Space>
        )}
      />
    </div>
  );
}
